import type { Notification } from './types';

export type ChatToastTarget = { conversationId: string; viewerId: string; notificationId: string };
export type Toast = {
  id: number;
  message: string;
  kind: 'success' | 'error' | 'info';
  chat?: ChatToastTarget;
};

/** A repeated failure stays one notification until it is dismissed or expires. */
export function addToast(items: Toast[], next: Toast): Toast[] {
  if (
    items.some((item) =>
      next.chat
        ? item.chat?.notificationId === next.chat.notificationId
        : !item.chat && item.message === next.message && item.kind === next.kind,
    )
  )
    return items;
  return [...items.slice(-3), next];
}

export function newMessageNotices(
  previous: Notification[],
  current: Notification[],
  since: number,
) {
  const known = new Set(previous.map((notice) => notice.id));
  return current
    .flatMap((notice) => {
      const match = /^\/messages\/([a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12})$/i.exec(notice.path);
      return notice.type === 'messages' &&
        !notice.read &&
        !known.has(notice.id) &&
        Date.parse(notice.created_at) >= since &&
        match
        ? [{ notice, conversationId: match[1] }]
        : [];
    })
    .slice(0, 4)
    .reverse();
}
